import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "club-content" }
const _hoisted_2 = { class: "body text-grey-900" }
const _hoisted_3 = ["innerHTML"]

import state from "../state/state";

export default /*@__PURE__*/_defineComponent({
  __name: 'InfantClubContent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).infantClubs, (club, club_i) => {
      return (_openBlock(), _createElementBlock("div", { key: club_i }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(club.clubName), 1),
        _createElementVNode("span", {
          class: "caption text-grey-700 ms-2",
          innerHTML: club.minAndMaxAge
        }, null, 8, _hoisted_3)
      ]))
    }), 128))
  ]))
}
}

})